import { call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import { getCompanies, registerCompany, suspendCompany } from '../utils/requests';
import { fetchCompaniesSuccess, fetchCompaniesFailed, registerCompanySuccess, registerCompanyFailed , fetchCompaniesRequest, suspendCompanySuccess, suspendCompanyFailed} from '../actions/company';

export function* companyWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.FETCH_COMPANIES_REQUEST, companyRequestWatcher);
}

function* companyRequestWatcher() {
    try {
      const response = yield call(getCompanies);
      yield put(fetchCompaniesSuccess(response.data));

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(fetchCompaniesFailed(errorPayload));

    }
}

export function* registerCompanyWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.REGISTER_COMPANY_REQUEST, registerCompanyRequestWatcher);
}



function* registerCompanyRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(registerCompany, payload);

      yield put(registerCompanySuccess(response.data));
      

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      
      yield put(registerCompanyFailed(errorPayload));
    }
}

export function* suspendCompanyWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.SUSPEND_COMPANY_REQUEST, suspendCompanyRequestWatcher);
}



function* suspendCompanyRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(suspendCompany, payload);

      yield put(suspendCompanySuccess(response.data));
      yield put(fetchCompaniesRequest());
      

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      
      yield put(suspendCompanyFailed(errorPayload));
    }
}